import { gql } from '@apollo/client';
import { ScheduleFieldsFragment } from './fragments';

export const SCHEDULE_LIMITS_AND_NAMES = gql`
  query scheduleConfig {
    scheduleConfig {
      limits {
        type
        exceeded
        maxCount
      }
      alertThresholdCompareOps {
        key
        display
        requireComparison
      }
      names
    }
  }
`;

export const GET_SCHEDULE = gql`
  query getSchedule($scheduleId: ID!) {
    scheduleGet(id: $scheduleId) {
      ...ScheduleFields
    }
  }
  ${ScheduleFieldsFragment}
`;
